window.addEventListener("scroll", function () {
    const scrolled = window.scrollY;

    for (let i = 1; i <= 10; i++) {
        const position = 100 * Math.ceil(i / 2);
        const className = `scrolled${position}`;

        if (scrolled > position) {
            document.body.classList.add(className);
        } else {
            document.body.classList.remove(className);
        }
    }
});
